module.exports = __webpack_public_path__ + "static/media/img1.5f552531.png";